module.exports = __webpack_public_path__ + "img/plus-icon.e6394e43.svg";